import initialState from './initialState'

/**
 * @description
 * set status
 * 
 * @param {object} state
 * @return {void}
 */
const authRequest = (state) => {
    state.status = 'loading'
}

/**
 * @description
 * set status, token, user and hasLoadedOnce after success user login
 * 
 * @param {object} state
 * @return {void}
 */
const authSuccess = (state, token) => {
    state.status = 'success'
    state.token = token
    state.user = JSON.parse(localStorage.getItem('user'))
    state.hasLoadedOnce = true
}

/**
 * @description
 * set status and HasLoadedOnce after error login
 * @param {object} state
 * @return {void} 
 */
const authError = (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
}

/**
 * @description
 * 
 * set token to void after user logout
 * @param {Object} state
 * @return {void} 
 */
const authLogout = (state) => {
    state.token = ''
}

/**
 * @description
 * 
 * Returns State to it's initial values
 * @param {*} state
 */
const resetState = (state) => {
    Object.assign(state, initialState())
}

export default {
    authRequest,
    authSuccess,
    authError,
    authLogout,
    resetState,
}